import { acountService } from '@/api'
// import { appUser, storage } from '@/utils'
import { AsyncRequest } from '@/utils/request'
import { Toast } from 'vant'
import { appUser } from '@/utils'
import {
  vconsole_log
} from '@/utils'

const state = {
  acountInfo: {}, // 全部账号信息
  errorPhone: '',
  errorCode: 0, // 合并code   不为0时,转到添加班主任页面
  changeType: '', // 账号合并的类型  "ACC_WX_OLD",
  activeIndex: 0, // 选中项
  previewList: [], // 预合并账号信息
  list: [], // 用户账号列表
  isNative: appUser.isNative, // 是否原生环境
  isWeixin: appUser.isWeixin // 是否微信环境
}

const getters = {
  acountInfo: state => state.acountInfo,
  activeIndex: state => state.activeIndex,
  list: state => state.list,
  previewList: state => state.previewList,
  changeType: state => state.changeType,
  errorCode: state => state.errorCode,
  errorPhone: state => state.errorPhone,
  isNative: state => state.isNative,
  isWeixin: state => state.isWeixin,
  unChoose: state => {
    if (state.list.length === 0) return {}
    if (state.list.length > 0) { return state.list.filter((item, index) => state.activeIndex !== index)[0] }
  }
}

const mutations = {
  // 多账户信息
  setAccount: (state, account) => {
    const { aAccount = {}, bAccount = {}, changeType } = account;
    state.acountInfo = account
    state.changeType = changeType
    state.errorPhone = aAccount?.mobile ? aAccount?.mobile : bAccount?.mobile
    vconsole_log('[state.acountInfo----]', state.acountInfo)
    vconsole_log('[state.changeType----]', state.changeType, '[errorPhone---]', state.errorPhone)
  },
  upList: (state, list) => {
    state.list = list;
  },
  upPreviewList: (state, list) => {
    state.previewList = list;
  },
  upIndex: (state, index) => {
    state.activeIndex = index;
  },
  // 其它错误情况
  errorCode: (state, code) => {
    state.errorCode = code;
  }
}

const actions = {
  // 多账号查询
  AcountQuery({ commit }, data) {
    return AsyncRequest({
      loading: true,
      request: () => acountService.AcountQuery(data),
      resolve: (account) => {
        commit('setAccount', account)
        commit('upList', [account.aAccount || {}, account.bAccount || {}])
        commit('upPreviewList', [account.previewA || {}, account.previewB || {}])
        commit('errorCode', 0);
      },
      reject: (error) => {
        const account = error.data;
        commit('upList', [account.aAccount || {}, account.bAccount || {}])
        commit('upPreviewList', [account.previewA || {}, account.previewB || {}])
        commit('setAccount', account)
        commit('errorCode', error.code);
      }
    })
  },
  // 账号合并
  AcountCombine({ commit }, data) {
    return AsyncRequest({
      request: () => acountService.AcountCombine(data),
      resolve: (result) => console.log('合并result-------', result),
      reject: (error) => { Toast(error.message); console.log(error) }
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
